import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

interface Props {
  heading: string;
  src?: string;
  videoEl?: React.ReactNode;
  btn?: React.ReactNode;
  shouldPlay?: boolean;
}

const ReviewVideoBlock: React.FC<Props> = (props) => {
  const { heading, src, videoEl, btn, shouldPlay } = props;

  const [isVideoLoading, setIsVideoLoading] = useState(true);

  const videoRef = useRef<HTMLVideoElement | null>(null);

  // play when shouldPlay changes
  useEffect(() => {
    if (shouldPlay && videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(console.error);
    }
  }, [shouldPlay]);

  return (
    <div className="w-[calc((100%_-_3rem)_/_2)] sm:w-40 flex flex-col gap-2">
      {videoEl ? (
        videoEl
      ) : (
        <div className="aspect-[9/16] rounded-md overflow-hidden">
          {(isVideoLoading || !shouldPlay) && (
            <div className="w-full h-full skeleton" />
          )}

          <video
            ref={videoRef}
            src={src}
            className={classNames(
              'w-full h-full object-contain',
              isVideoLoading || !shouldPlay ? 'hidden' : '',
            )}
            muted
            loop
            playsInline
            preload="auto"
            onCanPlay={() => setIsVideoLoading(false)}
          />
        </div>
      )}

      <div className="flex flex-col">
        <div className="font-semibold">{heading}</div>
        {btn}
      </div>
    </div>
  );
};

export default ReviewVideoBlock;
